// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3813) return "static/chunks/3813-ff38c9e0f7afbb64.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7410":"7f0900426ffc35ce","7439":"20faa5a1fb78bf54","9820":"a7b47488670630a5"}[chunkId] + ".js";
};